module.exports = __webpack_public_path__ + "img/icon_EURUSD.f76cd151.png";